import Vue from 'vue'
import VueAxios from 'vue-axios'
import { VueAuthenticate } from 'vue-authenticate'
import axios from 'axios'

import { api, providers } from '@/config'
import router from '@/routes/router'
import graphql from '@/api/graphql'
import gql from 'graphql-tag'

const handleError = function (response, title, dispatch) {
  if (response instanceof Promise) {
    console.log('unexpected error type Promise')
  //   response.then(json => {
  //     // Note this is not the http response object, its a graphql response
  //     console.log(json)
  //     dispatch('notify', { title: title, message: json.errors })
  //   })
  //   .catch(e => {
  //     console.log(e)
  //     dispatch('notify', title + ' ' + e)
  //   })
  // } else if (response instanceof Error) {
  } else if (response instanceof Error) {
    if (response.response && response.response.data && response.response.data.errors) {
      console.log(response.response)
      dispatch('notify', { title: title, message: response.response.data.errors })
    } else {
      console.log(response.message)
      dispatch('notify', title + ' ' + response.message)
    }
  } else {
    console.log(response)
    dispatch('notify', title + ' ' + response)
  }
}

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
axios.defaults.headers.post['X-Timezone'] = timezone

Vue.use(VueAxios, axios)
export const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: api.baseUrl,
  tokenPath: 'session.token',
  providers: providers
})

// state

// getters
const getters = {
  // See https://vuex.vuejs.org/guide/getters.html#method-style-access
  // Without the two functions we get the Webpack 'isAuthenticated' is not a function error.
  isAuthenticated: () => () => {
    let isAuth = vueAuth.isAuthenticated();
    return isAuth;
  },

  tokenPayload: () => () => {
    let token = vueAuth.getToken()
    // See https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(atob(base64)) //.split('').join(''))
    return JSON.parse(jsonPayload)
  }
}

// actions
const actions = {
  authProvider ({dispatch}, { provider }) {
    vueAuth.authenticate(provider).then((response) => {
      router.push(`${process.env.BASE_URL}`)
    })
    .catch((response) => {
      handleError(response, 'Could not login via ' + provider, dispatch)
      // console.log(response)
    })
  },

  authRegister({dispatch}, { name, email, password }) {
    vueAuth.register({ name: name, email: email, password: password})
      .then((response) => {
        router.push(`${process.env.BASE_URL}`)
      })
      .catch((response) => {
        // console.log(response)
        handleError(response, 'Signup error:', dispatch)
      })
  },

  authLogin({dispatch}, { email, password }) {
    vueAuth.login({ email: email, password: password})
      .then((response) => {
        router.push(`${process.env.BASE_URL}`)
      })
      .catch((response) => {
        if (response.response && response.response.status == 403) {
          dispatch('notify', 'Invalid email address or password')
        } else {
          handleError(response, 'Login error:', dispatch)
          // console.log(response)
        }
      })
  },

  authLogout(context) {
    vueAuth.logout()
    router.push(`${process.env.BASE_URL}auth/login`)
  },

  authEmulate({dispatch, commit}, {action, userId}) {
    let input = {
      action: action
    }
    if (action == 'acquire') {
      input.id = userId
    }
    let graphQuery = gql`mutation UserEmulate($action: String!, $id: ID) {
      userEmulate(id: $id, action: $action) {
        id,
        action,
        token
      }
    }`
    graphql.query(graphQuery, input)
    .then(json => {
      // router redirect to user level profile of the emulated user
      vueAuth.setToken({
        session: {
          token: json.data.userEmulate.token
        }
      })
      if (json.data.userEmulate.action == 'acquire') {
        dispatch('notify', { type: 'success', message: 'Logged in as this user'})
        router.push(`${process.env.BASE_URL}profile`)
      } else {
        dispatch('notify', { type: 'success', message: 'User emulation ended'})
      }
      dispatch('userGetProfile')
    })
    .catch(gqlResponse => {
      graphql.handleError(gqlResponse, 'Error setting auth state:', dispatch)
    })
  }

}

export default {
  getters,
  actions
}